import React, { useEffect, useState } from "react";
import axios from "axios";
import QuoteCard from "./quoteCard";
import { API_BASE_URL } from "../../config";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { getCookie } from "../../utils";
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography";
import SmeStepper from "../common/Stepper/Stepper";
import List from "@mui/material/List";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import ViewBenefits from "../modals/ViewBenefitsModals";
import SmeSnackbar from "../common/Snackbar";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useNavigate } from "react-router-dom";
import NewQuoteCard from "./NewQuoteCard";
import CookiesHelper from "../../utils/cookiesHelper";

const Quote = ({ sessionHandler }) => {
  const [quoteData, setQuoteData] = useState(null);
  const [quoteStatus, setQuoteStatus] = useState(false)
  const navigate = useNavigate();
  const [quoteIsNotAllowed, setQuoteIsNotAllowed ] = useState(false)
  const [showBenefits, setShowBenefits] = useState({display:false,cateriories:{}})
  const [showCustomizeCard, setShowCustomizeCard] = useState(true);
  const voAuthToken = getCookie('vo-auth-token')
  const agent = getCookie('vo-login-id')
  const leadDetails = JSON.parse(sessionStorage.getItem("leadDetails"))
  const [snackBarDetails,setSnackBarDetails] = useState({display:'',message:''})

  const notesListItems = [
    "Ensure RFQ is in place",
    "Share the quote to Partner to take their approval",
    "Collect as much documents/information as possible - checklist, approved quote, list of insured person, cheque scan copy, PAN copy, bank details, client request mail.",
    " Submit the required documents along with cheque to the nearest branch.",
    " Follow up on Quote analysis / processing and incorporation of terms and conditions to close the deal.",
  ]

  const getPremium = () => {
    if(leadDetails?.leadId){
    axios
      .get(`${API_BASE_URL}/sme-api/lead/${leadDetails.leadId}/premium`, {
        headers: {
          token:CookiesHelper.getAccessToken()
        },
      })
      .then(( {data} ) => {        
        if (
          data.data.sumInsured.length === 1 &&
          data.data.sumInsured.includes("2 Lakhs")
        )
          setShowCustomizeCard(false);
        setQuoteData(data.data);
        setQuoteStatus(true);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          console.error('Bad Request:', error.response.data);
          sessionHandler()
        }
        if (error.response && error.response.status === 400) {
          console.error('Bad Request:', error.response.data);
          setQuoteIsNotAllowed(true)  
        }
      });
    }
  };

  useEffect(() => {
    getPremium();
  }, []);

  const handleDiscountUpdate = (data) => {
      if(data && data.quoteType==='base'){
        setQuoteData((prev)=>
           {
            return {...prev,
                insurancePremium:{...prev.insurancePremium,basePremium:data.discountedPremium},
                earnings:{...prev.earnings,baseEarning:data.earning},
                commissionAndDiscount:{...prev.commissionAndDiscount,base:{
                  ...prev.commissionAndDiscount.base,commission:data.commission, discount:data.discount
                }}
            }
        })
      }
      else if(data && data.quoteType==='maternity'){
        setQuoteData((prev)=>
          {
           return {...prev,
               insurancePremium:{...prev.insurancePremium,maternityPremium:data.discountedPremium},
               earnings:{...prev.earnings,maternityEarning:data.earning},
               commissionAndDiscount:{...prev.commissionAndDiscount,maternity:{
                 ...prev.commissionAndDiscount.maternity,commission:data.commission, discount:data.discount
               }}
           }
       })
      }
      else if(data && data.quoteType==='customized'){
        setQuoteData((prev)=>
          {
           return {...prev,
               insurancePremium:{...prev.insurancePremium,customizedPremium:data.discountedPremium},
               earnings:{...prev.earnings,customizedEarning:data.earning},
               commissionAndDiscount:{...prev.commissionAndDiscount,customized:{
                 ...prev.commissionAndDiscount.customized,commission:data.commission, discount:data.discount
               }}
           }
       })
      }
  }

  return (
    <>
      <SmeSnackbar open={snackBarDetails.display} message={snackBarDetails.message} handleClose={()=>setSnackBarDetails({display:false})} />
      {showBenefits.display && <ViewBenefits cateriories={showBenefits.cateriories} onClose={() => setShowBenefits((prev)=>({...prev,display:false}))} />}
      <SmeStepper />
      <Container className="quote-wrapper ">
        {quoteStatus && <Box className="col-sm-12">
          <Typography fontSize={'18px'} fontWeight={'600'}>Quote Generated</Typography>
          <Typography fontSize={'14px'} color={'#666666'}>Checkout below recommended plans</Typography>
        </Box>}
        {quoteStatus ? (
          <Stack flexDirection='row' padding={'30px 0px'}>
            <div className="col-sm-12">
              <div className="">
                <Swiper
                  slidesPerView={1.1}
                  spaceBetween={10}
                  centeredSlides={true}
                  //loop={window.innerWidth < 600 ? true : false}
                  pagination={{
                    clickable: true,
                  }}
                  breakpoints={{
                    640: {
                      slidesPerView: 2,
                      spaceBetween: 20,
                    },
                    768: {
                      slidesPerView: 3,
                      spaceBetween: 40,
                    },
                    1024: {
                      slidesPerView: 3,
                      spaceBetween: 50,
                    },
                  }}
                  modules={[Pagination]}
                  className="mySwiper quote-swiper"
                >
                  {false && quoteData.insurancePremium.basePremium &&  (quoteData?.policyType === "market_renewal" ||  quoteData?.policyType === "star_renewal") &&(
                    <SwiperSlide>
                      <QuoteCard
                        cardTitle="Base"
                        tag="Basic"
                        leadId={quoteData.leadId}
                        type="base"
                        premium={quoteData.insurancePremium.basePremium}
                        totalEmp={quoteData.peoplesCount}
                        company={quoteData.companyDetails}
                        totalPeopleCount={quoteData.insurancePremium.peopleCount}
                        leadType={quoteData?.policyType}
                        earning={quoteData?.earnings?.baseEarning}
                        showBenefits={() => setShowBenefits((prev)=>({...prev,display:true,cateriories:{}}))}
                        discountDetails={quoteData?.commissionAndDiscount?.base}
                        handleSnackBar={(details)=>setSnackBarDetails(details)}
                        handleDiscountUpdate={(data)=>handleDiscountUpdate(data)}
                        sessionHandler={sessionHandler}
                      />
                    </SwiperSlide>
                  )}
                  {/* {quoteData.insurancePremium.maternityPremium && quoteData?.policyType !== "market_renewal" && (
                    <SwiperSlide>
                      <QuoteCard
                        cardTitle="Base + Maternity"
                        tag="Maternity"
                        leadId={quoteData.leadId}
                        premium={
                          quoteData.insurancePremium.maternityPremium
                        }
                        type="maternity"
                        totalEmp={quoteData.peoplesCount}
                        company={quoteData.companyDetails}
                        totalPeopleCount={quoteData.insurancePremium.peopleCount}
                        showBenefits={(cateriories={}) => setShowBenefits((prev)=>({display:true,cateriories:{...prev.cateriories,...cateriories}}))}
                        earning={quoteData?.earnings?.maternityEarning}
                        discountDetails={quoteData?.commissionAndDiscount?.maternity}
                        handleSnackBar={(details)=>setSnackBarDetails(details)}
                        handleDiscountUpdate={(data)=>handleDiscountUpdate(data)}
                        sessionHandler={sessionHandler}
                      />
                    </SwiperSlide>
                  )} */}
                  {/* {quoteData.insurancePremium.totalPremium.withBuffer && (
                  <SwiperSlide>
                    <QuoteCard
                      cardTitle="Base + Buffer"
                      tag="With Buffer"
                      premium={
                        quoteData.insurancePremium.totalPremium.withBuffer
                      }
                      totalEmp={quoteData.insurancePremium.totalEmployee}
                      company={quoteData.companyDetails}
                    />
                  </SwiperSlide>
                )} */}
                  {
                    false && quoteData.insurancePremium.customizedPremium && quoteData?.policyType !== "market_renewal" && (
                      <SwiperSlide>
                        <QuoteCard
                          cardTitle="Base + Customised"
                          tag="Customized"
                          premium={
                            quoteData.insurancePremium.customizedPremium
                          }
                          type="customized"
                          leadId={quoteData.leadId}
                          totalEmp={quoteData.peoplesCount}
                          company={quoteData.companyDetails}
                          callPremium={getPremium}
                          addon={quoteData.addOns}
                          totalPeopleCount={quoteData.insurancePremium.peopleCount}
                          onlyEnployee={
                            quoteData.insurancePremium.isEmployeeOnly
                              ? quoteData.insurancePremium.isEmployeeOnly
                              : false
                          }
                          showBenefits={(cateriories={}) => setShowBenefits((prev)=>({display:true,cateriories:{...prev.cateriories,...cateriories}}))}
                          earning={quoteData?.earnings?.customizedEarning}
                          discountDetails={quoteData?.commissionAndDiscount?.customized}
                          handleSnackBar={(details)=>setSnackBarDetails(details)}
                          handleDiscountUpdate={(data)=>handleDiscountUpdate(data)}
                          sessionHandler={sessionHandler}
                          is2LakhSI={showCustomizeCard}
                        />
                      </SwiperSlide>
                    )}
                </Swiper>
              </div>
            </div>
            {/* <div className="col-sm-12">
            <button className="btn btn-primary">Download Quote</button>
            <button className="btn btn-primary"></button>
          </div> */}
          </Stack>
        ) : null}
        {quoteIsNotAllowed && 
          <Box 
            sx={{
            boxShadow: '0px 8px 8px -4px #10182808',
            background:'#ffffff',
            padding:'10px',
            borderRadius:'12px'}}
            width={'400px'}
            margin={'auto'}
            >
            <Stack 
              gap={'8px'}
            >
              <Stack 
                justifyContent={'center'} 
                alignItems={'center'} 
                padding={'2px'} 
                width='40px' 
                height={'40px'} 
                borderRadius={'50%'}
                backgroundColor={'#FEE4E2'}
                >
                   <Icon width={'26px'} height={'26px'} icon="material-symbols:info-outline-rounded" color="#D92D20"/>
              </Stack>
            <Typography fontWeight={'700'}>Quick Quote is not allowed</Typography>
            <Typography marginBottom={'12px'} fontWeight={'400'} fontSize={'14px'} color={'#475467'}>Please contact corporate underwriting team to get the quote for this lead.</Typography>
              <Button 
                variant="contained"
               onClick={() => {
                navigate("/Dashboard");
            }}
              >
                My Dashboard
                </Button>
            </Stack>
          </Box>
        }
        {/* {quoteData?.policyType === "market_renewal" && <div style={{ padding: '50px 0px 0px 0px', fontWeight: 600 }}>
          *The premium displayed / approved is indicative only. However kindly contact corporate office for final approval of the quote.
        </div>} */}
        {/* {quoteStatus && <Box
          sx={{ padding: '16px 24px' }}
          boxShadow={'0px 2px 24px 0px #0000000D'}
          borderRadius={'17px'}
          bgcolor={'#ffffff'}
          marginTop={'60px'}
        >
          <Typography fontSize={'16px'} fontWeight={'700'}>Note</Typography>
          <List>
            {notesListItems.map((each, index) => {
              return <Box key={index} >
                <Typography fontSize={'14px'}>{`${index + 1}. ${each}`}</Typography>
              </Box>
            })}
          </List>
        </Box>} */}
        {/* {quoteStatus && <Box
          sx={{ padding: '16px 24px' }}
          boxShadow={'0px 2px 24px 0px #0000000D'}
          borderRadius={'17px'}
          bgcolor={'#ffffff'}
          marginTop={'16px'}
        >
          <Typography fontSize={'16px'} fontWeight={'700'}>Terms and Conditions</Typography>
          <Typography fontSize={'14px'}>* Prices above are exclusive of GST.</Typography>
        </Box>} */}
      </Container>
      <Container className="quote-wrapper ">
      {(!quoteIsNotAllowed) &&  quoteData && <NewQuoteCard
           totalEmp={quoteData.peoplesCount}
           premium={
            quoteData?.policyType === "fresh"?quoteData.insurancePremium.customizedPremium:quoteData.insurancePremium.basePremium
          }
          discountDetails={quoteData?.policyType === "fresh"?quoteData?.commissionAndDiscount?.customized:quoteData?.commissionAndDiscount?.base}
          earning={quoteData?.policyType === "fresh"?quoteData?.earnings?.customizedEarning:quoteData?.earnings?.baseEarning}
          leadId={quoteData.leadId}
          policyType = {quoteData.policyType}
          type={quoteData?.policyType === "fresh"?"customized":'base'}
          handleSnackBar={(details)=>setSnackBarDetails(details)}
          handleDiscountUpdate={(data)=>handleDiscountUpdate(data)}
          addon={quoteData.addOns}
          showBenefits={(cateriories={}) => setShowBenefits((prev)=>({display:true,cateriories:{...prev.cateriories,...cateriories}}))}
          callPremium={getPremium}
          is2LakhSI={showCustomizeCard}
          />
          }
          {quoteStatus && <Box
          sx={{ padding: '16px 24px' }}
          boxShadow={'0px 2px 24px 0px #0000000D'}
          borderRadius={'17px'}
          bgcolor={'#ffffff'}
          marginTop={'60px'}
          border={'1px solid #D0D5DD'}
        >
          <Typography fontSize={'16px'} fontWeight={'700'}>Note</Typography>
          <List>
            {notesListItems.map((each, index) => {
              return <Box key={index} >
                <Typography color={'#475467'} fontSize={'14px'}>{`${index + 1}. ${each}`}</Typography>
              </Box>
            })}
          </List>
          <Box sx={{background:'#F2F6FC', width:'fit-content',border:'1px solid #CBDCF2',padding:'5px', fontSize:'12px',color:'#415EB4',borderRadius:'16px',fontWeight:'500'}}>
            <span style={{background:'#fff',border:'1px solid #CBDCF2',borderRadius:'16px',padding:'0px 5px'}}>T&C*</span> Prices above are exclusive of GST.</Box>
        </Box>}
      
      </Container>

    </>
  );
};

export default Quote;
